import { Box, Flex } from '@mantine/core';
import { FC } from 'react';
import { NotFound } from 'src/components/NotFound';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { ThemeDetails } from 'src/features/theme/feature-theme-details';

import { useThemeDetails } from './use-theme-details';
import { ActionFooter } from 'src/components/ActionFooter';

export const ThemeDetailsView: FC = () => {
  const { theme, isPending, isError, handleDelete, handleCancel } =
    useThemeDetails();

  if (isPending) {
    return <PageLoader visible={isPending} />;
  }

  if (isError || !theme) {
    return (
      <NotFound description="The theme you're looking for doesn't exist" />
    );
  }

  return (
    <Flex
      direction="column"
      gap="sm"
      justify="space-between"
      style={{ height: '100%' }}
    >
      <Box>
        <PageTitle title={theme.name} />
        <ThemeDetails theme={theme} />
      </Box>

      <ActionFooter
        onDelete={handleDelete}
        onCancel={handleCancel}
        showSubmitButton={false}
      />
    </Flex>
  );
};
